import AdminTermList from "./AdminTermList";

export default class AdminTerms extends AdminTermList {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return null;
  }
}
